(ns frontend.react.virtualized.scrollable-grid.header-grid
  (:require
   [cljsjs.react-draggable]
   [common.localization :as loc]
   [frontend.react.virtualized.scrollable-grid.common :as common-events]
   [frontend.react.virtualized.scrollable-grid.events :as events]
   [frontend.react.virtualized.scrollable-grid.header-selection-grid :as header-selection-grid]
   [frontend.utils :as fu]
   [reagent.core :as r]))

(defn header-cell-render
  [props js-args]
  (let [{:keys [columns pipeline custom-tools custom-header-renderer
                can-filter? resizing-column avail-width
                is-sorted-by? is-secondary-sorted-by?
                sort-by! reorder-columns! hover-atom hover-col hover-row]}
        props
        clj-args (js->clj js-args :keywordize-keys true)
        {:keys [columnIndex rowIndex style]} clj-args
        cell-key (:key clj-args)                                                                    ;; to avoid name clashing with key function
        select-cell? (zero? columnIndex)
        data-column-index (- columnIndex 1)
        {:keys [data-key filter-data update-filter!
                get-styling
                begin-width-update! update-width! end-width-update!]}
        (get columns data-column-index)
        sort-direction (is-sorted-by? data-key)
        secondary-sort-direction (is-secondary-sorted-by? data-key)

        ;; save the grid (react) component, so it can be referenced elsewhere
        hovering-this-cell? (or (= resizing-column data-key)
                                (and (not resizing-column)
                                     (= columnIndex hover-col)))
        col-width (events/calculate-current-column-width columns data-column-index avail-width)]
    (if-let [custom-renderer (and (fn? custom-header-renderer)
                                  (custom-header-renderer data-key))]
      (r/as-element
       (custom-renderer {:data-key data-key
                         :cell-key cell-key
                         :style    style}))
      (r/as-element
       (if select-cell?
         ^{:key   cell-key
           :style style}
         (header-selection-grid/view props style cell-key)
         [:div
          {:key           cell-key
           :style         (merge style
                                 {:will-change "transform"})
           :on-mouse-over (fn [_]
                            (swap! hover-atom assoc
                                   :hover
                                   {:col columnIndex
                                    :row -1}))
           :on-drag-enter (fn [e]
                            (.preventDefault e)
                            (swap! hover-atom assoc-in [:drag :column] data-key))
           :on-drag-over  (fn [e]
                            (.preventDefault e)
                            (aset e "dataTransfer" "effectAllowed" "move"))
           :on-drop       (fn [e]
                            (.preventDefault e)
                            (.stopPropagation e))
           :class-name    (fu/cs "px-2 flex items-center bg-base-light border-l border-r border-t-2 border-b-2 border-solid border-base-light-border-paler cursor-move"
                                 (when (fn? get-styling)
                                   (get-styling))
                                 (when (or (= resizing-column data-key)
                                           (and (not resizing-column)
                                                (= columnIndex hover-col)))
                                   "hover-col")
                                 (when (or (= resizing-column data-key)
                                           (and (nil? resizing-column)
                                                (= hover-row -1)))
                                   "hover-row")
                                 (when (and (not resizing-column)
                                            (-> @hover-atom
                                                :drag
                                                :column
                                                (= data-key)))
                                   "drag-over-column")
                                 (if (odd? rowIndex) "odd" "even"))}
          [:div
           {:class "w-full flex items-center gap-2"}
           [:span.zap-grid__scrollable__header-text.drag-area
            {:class         "text-base-light-text cursor-pointer relative z-20 "
             :draggable     true
             :on-drag-start (fn [e]
                              (aset e "dataTransfer" "effectAllowed" "move")
                              ;;drag data must be set for dragend to fire in firefox:
                              (.. e -dataTransfer (setData "text" "zapflow"))
                              (swap! hover-atom assoc-in [:drag :column] data-key))
             :on-drag-end   (fn [me]
                              (.preventDefault me)
                              (.stopPropagation me)
                              (reorder-columns! data-key
                                                (-> @hover-atom
                                                    :drag
                                                    :column))
                              (swap! hover-atom update-in [:drag] dissoc :column))
             :on-drop       (fn [_e])
             :on-click      (fn [_e]
                              (when sort-by!
                                (sort-by! data-key
                                          (if (and sort-direction
                                                   (= sort-direction "ASC"))
                                            "DESC"
                                            "ASC"))))}
            (str (-> columns
                     (get data-column-index)
                     :label))]
           (when (and custom-tools hovering-this-cell?)
             (->> (custom-tools data-key)
                  (map (fn [custom-tool]
                         (let [tool-id (str cell-key "-custom-tool-dropdown-" (:tool-id custom-tool))]
                           [:i
                            {:key        tool-id
                             :class-name (fu/cs :fal (:tool-icon custom-tool) "text-base-light-text hover:text-base-light-text-accent flex gap-1 items-center cursor-pointer")
                             :on-click   (partial (:on-click! custom-tool) data-key)}])))
                  (doall)))
           (when (and hovering-this-cell? can-filter? (can-filter? data-key))
             [:i
              {:class    "m-0 fal fa-filter text-sm cursor-pointer"
               :on-click (partial common-events/open-filter-curtain
                                  {:field-key      data-key
                                   :pipeline       pipeline
                                   :current-filter filter-data
                                   :update-fn!     update-filter!})}])
           (when (or hovering-this-cell?
                     (some #{sort-direction secondary-sort-direction} ["DESC" "ASC"]))
             [:span
              {:class    "text-base-light-text cursor-pointer"
               :on-click (fn [e]
                           (.preventDefault e)
                           (.stopPropagation e)
                           (when sort-by!
                             (sort-by! data-key
                                       (if (and sort-direction
                                                (= sort-direction "ASC"))
                                         "DESC"
                                         "ASC"))))}
              (case sort-direction
                "DESC" [:i.fas.fa-sort-down]
                "ASC" [:i.fas.fa-sort-up]
                (case secondary-sort-direction
                  "DESC" [:i
                          {:class (fu/cs "fal" "fa-sort-down" "secondary-sort")}]
                  "ASC" [:i
                         {:class (fu/cs "fal" "fa-sort-up" "secondary-sort")}]
                  [:i.fal.fa-sort]))])

           (when hovering-this-cell?                                                                ;;TODO if column is resizable
             [:> js/ReactDraggable
              {:axis     "x"
               :onStart  (fn [me _de]
                           (let [mouse-event (js->clj me :keywordize-keys true)
                                 screen-x (aget mouse-event "screenX")]
                             (.preventDefault me)
                             (.stopPropagation me)
                             (begin-width-update! col-width screen-x)))
               :onDrag   (fn [me _drag-e]
                           (let [mouse-event (js->clj me :keywordize-keys true)
                                 screen-x (aget mouse-event "screenX")]
                             (.preventDefault me)
                             (.stopPropagation me)
                             (update-width! screen-x)))
               :onStop   (fn [me _de]
                           (.preventDefault me)
                           (.stopPropagation me)
                           (end-width-update!))
               :position {"x" 0}}

              [:span
               {:class-name      (fu/cs "zap-grid__scrollable__header-resizer" (when hovering-this-cell? "resizing"))
                :on-double-click (fn [_e]
                                   (update-width! nil))}
               "|"]])]])))))

(defn header-grid
  [_args]
  (fn [args]
    (let [{:keys [col-count header-height
                  avail-width overscan-count
                  column-width-fn
                  scroll-width scroll-left on-scroll
                  grid-store]}
          args
          scroll-fix (if
                      (and (> scroll-left 0)                                                        ; we have scrolled
                           (> (+ avail-width scroll-left) scroll-width))                            ;; scroll problem occurs
                       (- (+ avail-width scroll-left) scroll-width)
                       0)]
      (r/as-element
       (into
        [:> js/ReactVirtualized.Grid
         {:class-name            "zap-grid__header"
          :cell-renderer         (partial header-cell-render args)
          :column-width          (partial column-width-fn)
          :column-count          (+ col-count 1)
          :style                 {:left (str (- scroll-fix) "px")}
          :width                 avail-width
          :no-content-renderer   (fn [] [:div])
          :height                header-height
          :overscan-column-count overscan-count
          :row-height            header-height
          :overscan-row-count    0
          :scroll-left           scroll-left
          :on-scroll             on-scroll
          :row-count             1
          :ref                   (fn [component]
                                   ;; save the grid (react) component, so it can be referenced elsewhere
                                   ;; TODO: can this be done at creation of js/ReactVirtualized.Grid instead of here?
                                   (when (and component
                                              (not (= component (:header-grid @grid-store))))
                                     (swap! grid-store assoc :header-grid component)))}])))))

(defn action-view
  [_args]
  (fn [args]
    (let [{:keys [selected select-action-renderer row-count style]} args]
      [:div
       {:class "w-full h-[50px] bg-base-light flex items-center border-b-2 border-t border-solid border-base-light-border-paler [&_.cell-selected]:border-y-0 [&_.cell-selected]:border-solid  [&_.cell-selected]:border-s [&_.cell-selected]:border-e-1 [&_.cell-selected]:border-base-light-border-paler "}
       [header-selection-grid/view args style "header-selection-grid"]
       [:span
        {:class "h-full flex items-center m-0 ps-2 text-base-light-text text-sm font-bold"}
        (if (= selected :all)
          (loc/tr :all-selected [row-count])
          (loc/tr :selected-item-count [(count selected)]))]
       [:div
        {:class "px-4 flex gap-4 text-base-light-text cursor-pointer relative z-20"}
        [select-action-renderer]]])))

(defn view
  [_args]
  (fn [args]
    (let [selected (:selected args)
          ;; action-toolbar requires rewrite - disabling for now:
          new-action-view? false #_(get-in args [:new-action-view :in-use?])]
      [:div
       (if (and (not new-action-view?)
                (or (= selected :all)
                    (> (count selected) 0)))
         [action-view args]
         [header-grid args])])))
